/**
 * Ruby Health brand assets — uses the official gem SVG paths from logo_gem.svg.
 *
 * - <RubyLogo />      — full logo SVG (gem + "Ruby Health" text), for login/auth pages
 * - <RubyGemIcon />   — gem symbol only (inline SVG), for sidebar and compact contexts
 */

/** Full logo (gem + text) — served from public/ */
export function RubyLogo({ className = 'h-12' }: { className?: string }) {
  return <img src="/logo.svg" alt="Ruby Health" className={className} />;
}

/**
 * Official Ruby Health gemstone mark — inline SVG from logo_gem.svg.
 * Multi-faceted hexagonal gem with blue-to-purple radial gradient.
 */
export function RubyGemIcon({ size = 32 }: { size?: number }) {
  const id = 'ruby-gem-grad';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient
          id={id}
          cx="108.381" cy="109.524" r="173.939"
          fx="-31.79" fy="6.535"
          gradientTransform="matrix(0.9842 0.1772 -0.1391 0.7726 16.9549 5.6948)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.021" stopColor="#4598E9" />
          <stop offset="0.247" stopColor="#4695E7" />
          <stop offset="0.413" stopColor="#498CDF" />
          <stop offset="0.561" stopColor="#4F7CD1" />
          <stop offset="0.697" stopColor="#5665BE" />
          <stop offset="0.825" stopColor="#6048A6" />
          <stop offset="0.905" stopColor="#683293" />
        </radialGradient>
      </defs>
      {/* Outer facets + inner hexagon */}
      <path
        fill={`url(#${id})`}
        d="M0.9,113.2c4.1-35,22.4-66.8,50.8-87.9L38,76L0.9,113.2z
        M77.3,10.5c32.4-14,69.1-14,101.5,0L128,24.1L77.3,10.5z
        M204.4,25.3c28.3,21.1,46.7,52.9,50.8,87.9L218,76L204.4,25.3z
        M255.1,142.8c-4.1,35-22.4,66.8-50.8,87.9L218,180L255.1,142.8z M178.8,245.5c-32.4,14-69.1,14-101.5,0l50.8-13.6L178.8,245.5z
        M51.6,230.7c-28.3-21.1-46.7-52.9-50.8-87.9L38,180L51.6,230.7z M3,128l35-35v70L3,128z
        M65.5,19.7l47.8,12.8l-60.6,35L65.5,19.7z
        M190.5,19.7l12.8,47.8l-60.6-35L190.5,19.7z
        M253,128l-35,35V93L253,128z
        M190.5,236.3l-47.8-12.8l60.6-35L190.5,236.3z
        M65.5,236.3l-12.8-47.8l60.6,35L65.5,236.3z
        M50,173V83l78-45l78,45V173l-78,45L50,173z"
      />
      {/* Inner depth overlays */}
      <path opacity={0.5} fill="#682F92" d="M206,103.1v70l-78,45l-35.2-20.3L206,103.1z" />
      <path opacity={0.5} fill="#5B3C9D" d="M50,173v-70l113.2,94.7L128,218.1L50,173z" />
    </svg>
  );
}
